import React, {useEffect, useState, useRef} from 'react';
import {Grid, TablePagination} from '@material-ui/core';
import {useDispatch} from 'react-redux';
import {tableIcons} from './../../../components/TableIcons/index';
import {httpPaginationPost} from './../../../util/Rest';
import {defaultRows} from '../../../constants/ReusableTablePagination';
import GuiTable from './../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../constants/ReusableConstants';
import moment from 'moment';

export default function WorkQueueSearchTable({
  setSubmit,
  submit,
  searchData,
  reportMasterSearch,
  workQueueRowData,
}) {
  const columns = [
    {
      title: 'Account Number',
      field: 'userWqAccount',
    },
    {
      title: 'User Name',
      field: 'userName',
    },
    {
      title: 'Resolved Status',
      field: 'resolvedStatus',
      render: (rowData) => (rowData.resolvedStatus ? rowData.resolvedStatus : '-'),
    },
    {
      title: 'Start Date',
      field: 'startDttm',
      render: (rowData) => {
        return rowData?.startDttm ?
          moment.utc(rowData.startDttm).format('MM/DD/YYYY h:mm:ss A') :
          '';
      },
    },
    {
      title: 'End Date',
      field: 'endDttm',
      render: (rowData) => {
        return rowData?.endDttm ? moment.utc(rowData.endDttm).format('MM/DD/YYYY h:mm:ss A') : '';
      },
    },
  ];
  const tableRef = useRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);

  useEffect(() => {
    if (tableRef.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);

  const SearchSessionWorkQueue = JSON.parse(sessionStorage.getItem('WorkQueue'));
  if (SearchSessionWorkQueue && !submit) {
    searchData = SearchSessionWorkQueue;
  }

  return (
    <>
      <Grid item xs={12} className={'mt-3'}>
        <div className="custom-table  custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields">
          <GuiTable
            title={`${workQueueRowData?.workQueueCode} Activity`}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `workqueu/find/all/userwqaccount`;
                const bodyObj = {
                  userWQActivityId: workQueueRowData?.userWQActivityId || 0,
                  workQueueCode: workQueueRowData?.workQueueCode ?
                    workQueueRowData.workQueueCode :
                    '',
                  // workQueueCode: "",
                  userName: workQueueRowData?.userName ? workQueueRowData.userName : '',
                  // userName: "",
                  limit: query.pageSize ? query.pageSize : null,
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  orderDirection: query.orderDirection,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  startDttm: searchData?.workStartDttm ?
                    moment(searchData?.workStartDttm).format('MM/DD/YYYY') :
                    '',
                  endDttm: searchData?.lastUpdatedDttm ?
                    moment(searchData?.lastUpdatedDttm).format('MM/DD/YYYY') :
                    '',
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                        // setReportCode(null);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbarButtonAlignment: 'left',
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            localization={{
              header: {
                actions: reportMasterSearch ? '' : 'Actions',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <div className="mt-2"></div>
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
}
